import { createActions } from 'redux-actions'

export const {
  getCategoryListRequest,
  getCategoryListSucceed,
  getCategoryDetailRequest,
  getCategoryDetailSucceed,
  createCategoryRequest,
  createCategorySucceed,
  updateCategoryRequest,
  updateCategorySucceed,
  requestFailure
} = createActions(
  {
    GET_CATEGORY_LIST_REQUEST: ({ page, limit, q, sortBy, sortDirection }) => ({
      page,
      limit,
      q,
      sortBy,
      sortDirection
    }),
    GET_CATEGORY_LIST_SUCCEED: (categoryList) => categoryList,
    GET_CATEGORY_DETAIL_REQUEST: (categoryId) => categoryId,
    GET_CATEGORY_DETAIL_SUCCEED: (categoryDetail) => categoryDetail,
    CREATE_CATEGORY_REQUEST: (categoryDetail) => categoryDetail,
    CREATE_CATEGORY_SUCCEED: (categoryDetail) => categoryDetail,
    UPDATE_CATEGORY_REQUEST: ({ categoryId, categoryDetail }) => ({
      categoryId,
      categoryDetail
    }),
    UPDATE_CATEGORY_SUCCEED: (categoryDetail) => categoryDetail,
    REQUEST_FAILURE: (err) => err
  },
  { prefix: 'CATEGORY' }
)
